module.exports = __webpack_public_path__ + "static/media/1005577.372c6cf3.png";